import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { Auth } from '@aws-amplify/auth';

@Injectable({ providedIn: 'root' })
export class UserRoleGuard {
  constructor(private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    return Auth.currentSession()
      .then((session) => {
        const acceptedRoles = route.data['acceptedRoles'];
        const roles =
          session.getIdToken().payload['custom:impRoles']?.split(',') ??
          session.getIdToken().payload['cognito:groups'];
        if (acceptedRoles.some((role: string) => roles.includes(role))) {
          return true;
        } else {
          return this.router.createUrlTree(['']);
        }
      })
      .catch(() => {
        return this.router.createUrlTree(['']);
      });
  }
}
